import * as z from "zod/v4";

export const bulkAddTagsToPrompts = {
  name: "bulkAddTagsToPrompts" as const,
  input: z.object({
    promptIds: z.array(z.bigint()),
    tagIds: z.array(z.bigint()),
  }),
  output: z.object({}),
};
